<div class="text-center" *ngIf="progress">
  <h5>Aguarde. Carregando dados do CheckList.</h5>
  <p-progressBar mode="indeterminate" [style]="{'height': '4px'}"></p-progressBar>
</div>

<p-tabs [(value)]="activeTabValue" [scrollable]="true" [showNavigators]="true" class="tabs-sticky" (valueChange)="onTabChange($event)">
  <p-tablist>
    <p-tab value="0">
      <i class="pi pi-cog mr-2"></i>
      <span>Geral</span>
    </p-tab>

    <p-tab *ngIf="flagConAnexo" value="1">
      <i class="pi pi-paperclip mr-2"></i>
      <span>Anexos</span>
    </p-tab>

    <p-tab *ngIf="flagConToi" value="toi">
      <i class="pi pi-file-edit mr-2"></i>
      <span>TOI</span>
    </p-tab>

    <p-tab *ngFor="let tab of tabs; let i = index" [value]="'tab-' + i">
      <i [class]="tab.icon + ' mr-2'"></i>
      <span>{{ tab.header }}</span>
    </p-tab>

    <p-tab *ngIf="flagConMateriais" value="materiais">
      <i class="pi pi-exclamation-triangle mr-2"></i>
      <span>Materiais Aplicados</span>
    </p-tab>

    <p-tab *ngIf="flagConServicos" value="servicos">
      <i class="pi pi-list mr-2"></i>
      <span>Serviços Aplicados</span>
    </p-tab>

    <p-tab *ngIf="flagConMensagem" value="mensagens">
      <i class="pi pi-envelope mr-2"></i>
      <span>Mensagens</span>
    </p-tab>

    <p-tab *ngIf="flagConAtividadeComplementar" value="complementar">
      <i class="pi pi-folder-open mr-2"></i>
      <span>OS Complementar</span>
    </p-tab>

    <p-tab *ngIf="flagConManobras" value="manobras">
      <i class="pi pi-briefcase mr-2"></i>
      <span>Manobras</span>
    </p-tab>

  </p-tablist>

  <p-tabpanels>
    <p-tabpanel value="0">
      <div class="tab-panel-scroll">
        <mf-atividade-form
          (transformPDFEvent)="transformPDF($event)"
          (toiAtivoChange)="onToiAtivoChange($event)"
          [idAtividade]="idAtividade"
          [toiMidias]="detalheToi?.midias ?? []"
          [midiasOcultasPdf]="midiasOcultasPdf">
        </mf-atividade-form>
      </div>
    </p-tabpanel>

    <p-tabpanel *ngIf="flagConAnexo" value="1">
      <div class="tab-panel-scroll">
        <mf-atividade-anexo [idAtividade]="idAtividade"></mf-atividade-anexo>
      </div>
    </p-tabpanel>

    <p-tabpanel *ngFor="let tab of tabs; let i = index" [value]="'tab-' + i">
      <div class="tab-panel-scroll">
        <mf-atividade-checklist
          [idAtividade]="idAtividade"
          [header]="tab.header"
          [formJson]="tab.checkListTipoAtividades"
          [atvCheckList]="tab.atvCheckList"
          [showImages]="showImages">
        </mf-atividade-checklist>
      </div>
    </p-tabpanel>

    <p-tabpanel *ngIf="flagConMateriais" value="materiais">
      <div class="tab-panel-scroll">
        <mf-atividade-material
          #atividadeMateriais
          [idAtividade]="idAtividade">
        </mf-atividade-material>
      </div>
    </p-tabpanel>

    <p-tabpanel *ngIf="flagConServicos" value="servicos">
      <div class="tab-panel-scroll">
        <mf-atividade-servico
          #atividadeServicos
          [idAtividade]="idAtividade">
        </mf-atividade-servico>
      </div>
    </p-tabpanel>

    <p-tabpanel *ngIf="flagConMensagem" value="mensagens">
      <div class="tab-panel-scroll">
        <max-atividade-mensagens [idAtividade]="idAtividade"></max-atividade-mensagens>
      </div>
    </p-tabpanel>

    <p-tabpanel *ngIf="flagConAtividadeComplementar" value="complementar">
      <div class="tab-panel-scroll">
        <mf-atividade-os-vinculada [idAtividade]="idAtividade"></mf-atividade-os-vinculada>
      </div>
    </p-tabpanel>

    <p-tabpanel *ngIf="flagConManobras" value="manobras">
      <div class="tab-panel-scroll">
        <max-atividade-manobras [idAtividade]="idAtividade"></max-atividade-manobras>
      </div>
    </p-tabpanel>

    <p-tabpanel *ngIf="flagConToi" value="toi">
      <div class="tab-panel-scroll">
        <mf-toi-detalhe
          [detalhe]="detalheToi"
          [loading]="loadingToi"
          (backRequested)="onToiDetalheVoltar()"
          (saved)="onToiDetalheSalvo($event)"
          (pdfRequested)="exportarToiPdf()"
          (midiasOcultasChange)="midiasOcultasPdf = $event"
        ></mf-toi-detalhe>
      </div>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>

<div *ngIf="mostrarHtmlParaPdfToi" style="position: absolute; left: -9999px; top: 0">
  <mf-toi-export-pdf
    [pdfToi]="pdfToi"
    [detalhe]="detalheToi"
    [midiasOcultas]="renderPdfOficial ? midiasOcultasPdfOficial : midiasOcultasPdf"
  ></mf-toi-export-pdf>
</div>
